"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _WideDivider = require("./WideDivider");

var _WideDivider2 = _interopRequireDefault(_WideDivider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _WideDivider2.default;